import styled from "styled-components";

export const CourseCardsContainer = styled.div`
    display: flex;
    padding: 20px;
    width:100%;
    overflow: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* For iOS devices */
    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media(min-width: 768px){
        padding: 35px;
    }
    @media(min-width: 1024px){
        padding: 50px;
    }
`;

export const CategoryCard = styled.div`
    display: flex;
    justify-content: space-between;
    border-radius: 11px;
    position: relative;
    background-color: ${(props) => props.bgColor};
    box-shadow: 25px 25px 30px rgba(0, 0, 0, 0.75);
    overflow: hidden;
    border-color: #FFFFFF;
    border-width: thin;

    flex: 0 0 258px;
    height: 145px;
    margin-right: 26px;
    transition: transform .5s ease-in-out;
    @media(min-width: 768px){
        flex: 0 0 358px;
        height: 200px;
        margin-right: 40px;
    }
    @media(min-width: 1296px){
        flex: 0 0 458px;
        height: 245px;
        margin-right: 66px;
    }

    &:hover {
        cursor: pointer;
        transform: scale(1.1);
    }
`;

export const CategoryImage = styled.div`
    width: 45%;
    background-image: url(${(props) => props.imgURL});
    background-repeat: no-repeat;
    background-size: cover;
`;

export const CategoryTitle = styled.div`
    width: 50%;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 700;
    color: #FFFFFF;

    font-size: 20px;
    line-height: 28px;
    padding: 10px;
    @media(min-width: 768px){
        font-size: 25px;
        line-height: 30px;
        padding: 13px;
    }
    @media(min-width: 1296px){
        font-size: 33px;
        line-height: 40px;
        padding: 15px;
    }
`;

export const CategoryNumber = styled.div`
    position: absolute;
    font-family: heroregular;
    font-style: normal;
    color: #FFFFFF;
    bottom: 10px;
    left: 10px;
    font-weight: 700;
    font-size: 18px;
    @media(min-width: 768px){
        bottom: 15px;
        left: 15px;
        font-weight: 700;
        font-size: 21px;
    }
    @media(min-width: 1296px){
        bottom: 15px;
        left: 15px;
        font-weight: 700;
        font-size: 24px;
    }
`